import { StyleSheet } from 'react-native';

import { Fonts } from '../Themes';

export default StyleSheet.create({
  indicatorViewStyle: {
    flexDirection: 'row',
    height: 18,
    justifyContent: 'space-around',
    alignItems: 'center',
    marginRight: 10,
  },
  timeLabelsViewStyle: {
    justifyContent: 'center',
    width: 43,
    alignItems: 'center',
  },
  timeLabelsTextStyle: theme => ({
    lineHeight: 14,
    fontSize: 12,
    fontFamily: Fonts.type.VodafoneLt,
    color: theme.colors.headerColor,
  }),
  headerStyle: {
    flexDirection: 'row',
  },
  timeLabelsContainerStyle: {
    marginTop: 8,
    flexDirection: 'row',
    justifyContent: 'space-around',
  },
  columnsContainerStyle: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-around',
    height: 210,
    paddingTop: 10,
  },
  chartContainerStyle: {
    paddingVertical: 16,
  },
  infoLabelTextStyle: theme => ({
    lineHeight: 18,
    color: theme.colors.subtitle,
    fontSize: 14,
    marginLeft: 5,
  }),
  infoValueTextStyle: theme => ({
    lineHeight: 18,
    color: theme.colors.headerColor,
    fontSize: 14,
    marginLeft: 5,
  }),
});
